import { CreditCard } from '@sxm-de/dev-kits/microservices-sdk/types';
import {
    SxmTypeCreditCard,
    SxmTypeCreditCardStatus,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getDaysFromToday } from '../get-days-from-today';

export function mapSmsCreditCardToCreditCard(
    creditCard: CreditCard,
): SxmTypeCreditCard | null {
    if (!creditCard) {
        return null;
    }
    const {
        last4Digits,
        type,
        status,
        expiryMonth: expirationMonth,
        expiryYear: expirationYear,
    } = creditCard;

    /**
     * TODO:
     * Verify if timezones should be factored in
     */
    // Expiration date is the last day of the month
    // of the expiration date
    const expirationDate = new Date(
        [expirationMonth + 1, '1', expirationYear].join('/'),
    );
    expirationDate.setDate(-1);

    return {
        last4Digits,
        type,
        expirationMonth,
        expirationYear,
        status: status.toLowerCase() as SxmTypeCreditCardStatus,
        expirationDate: expirationDate,
        daysUntilExpiration: getDaysFromToday(expirationDate),
    };
}
